export enum ChangePasswordError {
  WRONG_OLD_PASSWORD = 'wrong_old_password',
  ALREADY_USED_PASSWORD = 'already_used_password'
}